import { computed, set } from '@ember/object';
export default function isIn(property, values) {
  return computed(property, '_isIn', {
    get() {
      if (this._isIn !== undefined) {
        return this._isIn;
      }
      return values.includes(this.get(property));
    },
    set(_, value) {
      return set(this, '_isIn', value);
    }
  });
}